/* Une pastille de carte mene a SON coloris, jamais au coloris d'ouverture.
   Le POURQUOI complet est dans _tools/pastille_coloris.py ; ce fichier n'en
   garde que ce qu'il faut pour le relire sans se tromper.

   Ce qu'on repare : sous chaque carte, la rangee de coloris etait decorative.
   Cliquer la troisieme pastille ouvrait la fiche sur le PREMIER coloris --
   « ca me remet sur le produit affiche a la base ». Une variante est le
   produit que l'on regarde : la pastille doit ouvrir la fiche sur elle.

   POURQUOI DU JAVASCRIPT ET PAS UN LIEN. La carte entiere est un <a>. Un
   second <a> a l'interieur est du HTML invalide : l'analyseur ferme le lien de
   la carte a cet endroit et le reste du bloc -- nom, prix, badge -- sort du
   lien. La pastille reste donc un <i>, et sa destination est composee ici, au
   clic. Meme raison que les fleches .sw-nav d'app.js, qui appellent deja
   preventDefault pour ne pas ouvrir la fiche.

   L'adresse n'est PAS ecrite dans le HTML : elle est composee de l'adresse
   portee par la carte plus le slug porte par la pastille. Une pastille ne peut
   donc jamais designer un autre produit que sa propre carte, et les 11 500
   pastilles du site ne pesent qu'un attribut chacune.

   Le slug est celui du catalogue -- celui-la meme qui nomme les images et que
   _tools/coloris_dans_url.py pose sur les fiches. On ne slugifie surtout pas
   le libelle affiche : il est traduit en francais sur une partie des fiches
   (« Ivoire / Heron » pour ivory-heron), et la carte et la fiche donneraient
   deux adresses differentes pour le meme coloris.

   Si le coloris n'existe plus a l'arrivee, app.js le dit : la fiche reste sur
   son coloris de depart et le parametre est retire de l'URL. Rien a faire
   ici. Et une pastille sans slug ne fait rien de special : le lien de la carte
   s'applique, comme avant. */
(function () {
  'use strict';

  var PARAM = 'coloris';

  function pastille(cible) {
    /* Le clic tombe sur le <img> de la pastille, pas sur le <i> qui porte le
       slug ; et il peut aussi tomber ailleurs dans la carte. */
    return cible && cible.closest ? cible.closest('.sw[data-coloris]') : null;
  }

  function destination(sw) {
    var carte = sw.closest('a.card');
    if (!carte) return '';
    var href = carte.getAttribute('href');
    var slug = sw.getAttribute('data-coloris');
    if (!href || !slug) return '';
    return href + (href.indexOf('?') < 0 ? '?' : '&') +
      PARAM + '=' + encodeURIComponent(slug);
  }

  function aller(e, ailleurs) {
    var sw = pastille(e.target);
    if (!sw) return;
    var url = destination(sw);
    if (!url) return;
    /* Sans ces deux lignes, le lien de la carte l'emporterait et ouvrirait la
       fiche sur son coloris de depart : le defaut qu'on corrige. */
    e.preventDefault();
    e.stopPropagation();
    if (ailleurs) window.open(url, '_blank', 'noopener');
    else location.href = url;
  }

  document.addEventListener('click', function (e) {
    if (e.button) return;
    /* Ctrl/Cmd/Maj + clic ouvre ailleurs, comme sur n'importe quel lien : on
       intercepte le clic, on ne prend pas l'habitude du navigateur en otage. */
    aller(e, !!(e.metaKey || e.ctrlKey || e.shiftKey));
  });

  document.addEventListener('auxclick', function (e) {
    if (e.button !== 1) return;   // clic du milieu : onglet neuf
    aller(e, true);
  });
})();
